import Image from "next/image";
import Link from "next/link";
import TFCounter from "@/components/Counters/TFCounter";
import BlogAuthor from "./Blog-Sections/Blog-Author";
// import ComntForm from "./Blog-Sections/ComntForm";
// import Comment from "./Blog-Sections/Comment";
import { MDXRemote } from 'next-mdx-remote'
// import CallToActionFour from "@/components/Call-To-Action/CallToAction-Four";
// import DisqusComments from "./Blog-Sections/DisqusComments";
import ImageSourceCaption from "../Media/ImageSourceCaption";
import { DateTime } from 'luxon';
import GoogleAdLarge from "../Ads/GoogleAdLarge";
import DisqusComments from "../Common/DisqusComments";

const TFModuleDetails = ({ blogType, tfModuleInfo, blogContent, author }) => {
  console.log(tfModuleInfo)

  const today = DateTime.fromISO(DateTime.now()).setLocale('en-US').toLocaleString(DateTime.DATE_FULL);

  const counterData = [
    {
      "tag": "DOWNLOADS METRICS",
      "title": "Module Downloads metrics from Terraform Registry",
      "subTitle": "Module Downloads metrics from Terraform Registry",
      "desc": "Data Snapshot as of " + today,
      "body": [
        {
          "text": "Downloads this week",
          "num": tfModuleInfo.downloads.week,
          "img": "/images/icons/counter-01.png",
          "top": true
        },
        {
          "text": "Downloads this month",
          "num": tfModuleInfo.downloads.month,
          "img": "/images/icons/counter-02.png",
          "top": false
        },
        {
          "text": "Downloads this year",
          "num": tfModuleInfo.downloads.year,
          "img": "/images/icons/counter-03.png",
          "top": true
        },
        {
          "text": "Downloads over all time",
          "num": tfModuleInfo.downloads.total,
          "img": "/images/icons/counter-04.png",
          "top": false
        }
      ]
    }]


  return (
    <>
      <div className="content">
        <div className="post-thumbnail mb--30 position-relative wp-block-image alignwide">
          <figure>
            {tfModuleInfo.image.poster && (
              <Image
                src={tfModuleInfo.image.poster}
                width={1085}
                height={645}
                priority
                alt="Blog Images"
              />
            )}
            {/* <figcaption>{tfModuleInfo.caption}</figcaption> */}
            <ImageSourceCaption sourceText={tfModuleInfo.image.source} />
          </figure>
        </div>

        <div className="rbt-counterup-area bg-color-white">
          <TFCounter isDesc={true} counterData={counterData} />
        </div>

        <MDXRemote {...blogContent} />
        {/* <blockquote className="wp-block-quote">
          <p>{tfModuleInfo.quote}</p>
          <cite>
            <Link href="https://themeforest.net/user/rainbow-themes/portfolio">
              {tfModuleInfo.city}
            </Link>
          </cite>
        </blockquote> */}

        {/* <div className="wp-block-gallery columns-3 is-cropped">
          <ul className="blocks-gallery-grid">
            {tfModuleInfo &&
              tfModuleInfo.gallery.map((item, innerIndex) => (
                <li className="blocks-gallery-item" key={innerIndex}>
                  <figure>
                    {item.galleryImg && (
                      <Image
                        className="radius-4"
                        src={item.galleryImg}
                        width={255}
                        height={143}
                        priority
                        alt="Blog Images"
                      />
                    )}
                  </figure>
                </li>
              ))}
          </ul>
        </div> */}

        {/* <h4>{tfModuleInfo.title}</h4> */}

        {/* <p>
          <Link href="#">{tfModuleInfo.linkOne}</Link> {tfModuleInfo.descTwo}
        </p>
        <p>{tfModuleInfo.descThree}</p>
        <h4>{tfModuleInfo.titleTwo}</h4>
        <p>
          <Link href="#">{tfModuleInfo.linkTwo}</Link> {tfModuleInfo.descSaven}
        </p>
        <div className="post-thumbnail mb--30 position-relative wp-block-image alignwide">
          <figure>
            {tfModuleInfo.addImg && (
              <Image
                src={tfModuleInfo.addImg}
                width={1085}
                height={645}
                priority
                alt="Blog Images"
              />
            )}

            <figcaption>{tfModuleInfo.caption}</figcaption>
          </figure>
        </div>
        <p>{tfModuleInfo.descFive}</p>
        <h4>{tfModuleInfo.titleTwo}</h4>
        <p>
          {tfModuleInfo.descSix}
          <Link href="#">{tfModuleInfo.linkThree}</Link>.
        </p>
        <p>
          <Link href="#">{tfModuleInfo.linkTwo}</Link> {tfModuleInfo.descFive}
        </p>
        <div className="tagcloud">
          {tfModuleInfo &&
            tfModuleInfo.tag.map((tagItem, innerIndex) => (
              <Link href="#" key={innerIndex}>
                {tagItem.tag}
              </Link>
            ))}
        </div>
        <div className="social-share-block">
          <div className="post-like">
            <Link href="#">
              <i className="feather feather-thumbs-up"></i>
              <span>2.2k Like</span>
            </Link>
          </div>
          <ul className="social-icon social-default transparent-with-border">
            {tfModuleInfo &&
              tfModuleInfo.social.map((socialItem, innerIndex) => (
                <li key={innerIndex}>
                  <Link href={socialItem.url}>
                    <i className={socialItem.icon}></i>
                  </Link>
                </li>
              ))}
          </ul>
        </div> */}

        {/* <div className="about-author">
          {tfModuleInfo &&
            tfModuleInfo.author.map((author, innerIndex) => (
              <BlogAuthor {...author} author={author} key={innerIndex} />
            ))}
        </div> */}

        {/* <div className="rbt-comment-area">
          <div className="rbt-total-comment-post">
            <div className="title">
              <h4 className="mb--0">30+ Comments</h4>
            </div>
            <div className="add-comment-button">
              <a
                className="rbt-btn btn-gradient icon-hover radius-round btn-md"
                href="#"
              >
                <span className="btn-text">Add Your Comment</span>
                <span className="btn-icon">
                  <i className="feather-arrow-right"></i>
                </span>
              </a>
            </div>
          </div>
          <ComntForm />
        </div> */}
        {/* <div className="rbt-comment-area">
          <h4 className="title">2 comments</h4>
          <ul className="comment-list">
            {tfModuleInfo &&
              tfModuleInfo.comment.map((comnt, innerIndex) => (
                <Comment {...comnt} comnt={comnt} key={innerIndex} />
              ))}
          </ul>
        </div> */}
        <GoogleAdLarge />
        <div className="about-author">
          <BlogAuthor author={author} />
        </div>

        <DisqusComments blogType={blogType} blog={tfModuleInfo} />

      </div>
    </>
  );
};

export default TFModuleDetails;
